import React from "react";
import type { RouteComponentProps } from "react-router";
import { UserForm } from "../shared/userForm";

type MatchParams = {
  idUsuario: string;
};

function UserEditionPage({ match }: RouteComponentProps<MatchParams>) {
  const userId = match.params.idUsuario;
  const parsedUserId = userId != null ? Number(userId) : null;

  return <UserForm userId={parsedUserId} />;
}

export default UserEditionPage;
